__turbopack_context__.v({
  "agencyAvailable": "AgencyHeader-module__AXwmIW__agencyAvailable",
  "agencyPicture": "AgencyHeader-module__AXwmIW__agencyPicture",
  "agencyPictureContainer": "AgencyHeader-module__AXwmIW__agencyPictureContainer",
  "agencySection": "AgencyHeader-module__AXwmIW__agencySection",
  "agencyTagContainer": "AgencyHeader-module__AXwmIW__agencyTagContainer",
  "alert": "AgencyHeader-module__AXwmIW__alert",
  "alertWrapper": "AgencyHeader-module__AXwmIW__alertWrapper",
  "breadcrumbWrapper": "AgencyHeader-module__AXwmIW__breadcrumbWrapper",
  "buttonWrapper": "AgencyHeader-module__AXwmIW__buttonWrapper",
  "detailValue": "AgencyHeader-module__AXwmIW__detailValue",
  "details": "AgencyHeader-module__AXwmIW__details",
  "detailsSection": "AgencyHeader-module__AXwmIW__detailsSection",
  "hero": "AgencyHeader-module__AXwmIW__hero",
  "iconQuote": "AgencyHeader-module__AXwmIW__iconQuote",
  "icons": "AgencyHeader-module__AXwmIW__icons",
  "local": "AgencyHeader-module__AXwmIW__local",
  "localHeroText": "AgencyHeader-module__AXwmIW__localHeroText",
  "ratingWrapper": "AgencyHeader-module__AXwmIW__ratingWrapper",
  "section": "AgencyHeader-module__AXwmIW__section",
  "title": "AgencyHeader-module__AXwmIW__title",
  "wordOfHeader": "AgencyHeader-module__AXwmIW__wordOfHeader",
  "wordOfSection": "AgencyHeader-module__AXwmIW__wordOfSection",
});
